import { jsonify, sanitize } from "../TapiocaUtils";
export default class CbsClient {
  constructor(raw) {
    this.raw = raw;
  }
  /**
   * Activates the component library and updates the membership of the
   * underlying project
   */
  activateLibrary(body) {
    const url = "/v1/library:activate";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Adds the component to each of the given projects
   */
  addToProjects(componentId, body) {
    const url = `/v1/components/${componentId}:add-to-projects`;
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Archives the given component, by soft removing the component from
   * existing projects.
   */
  archiveComponent(componentId, body) {
    const url = `/v1/components/${componentId}:archive`;
    return this.raw.post(url, jsonify(body));
  }
  callbackClone(body) {
    const url = "/v1/components/clone_completion_callback";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Creates a component entry for the given account
   */
  createComponent(body) {
    const url = "/v1/components";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Duplicate all components from the source project into the target project
   */
  duplicateToProject(body) {
    const url = "/v1/components:duplicate-to-project";
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Filters the collection of components
   */
  filterComponents(params) {
    const url = {
      url: "/v1/components",
      params: sanitize(params || {}, {
        "filter[failed]": "csv",
        "filter[pending]": "csv",
        sort: "csv",
      }),
    };
    return this.raw.get(url);
  }
  /**
   * Gets a component
   */
  getComponent(componentId, params) {
    const url = {
      url: `/v1/components/${componentId}`,
      params: sanitize(params || {}),
    };
    return this.raw.get(url);
  }
  /**
   * Gets the Component definitions for all component types.
   * Component definition is comprised a list of component names and the
   * corresponding list of attribute datatypes - on a per component type basis.
   */
  getComponentDefinitions() {
    const url = "/v1/components/component-definitions";
    return this.raw.get(url);
  }
  /**
   * Gets a paginated list of projects using the given component
   */
  getComponentUsage(componentId, params) {
    const url = {
      url: `/v1/components/${componentId}/usage`,
      params: sanitize(params || {}, {
        "filter[failed]": "csv",
        "filter[pending]": "csv",
      }),
    };
    return this.raw.get(url);
  }
  /**
   * Gets the component library
   */
  getLibrary(accountUid) {
    const url = `/v1/library/${accountUid}`;
    return this.raw.get(url);
  }
  /**
   * Removes the component from each of the given projects
   */
  removeFromProjects(componentId, body) {
    const url = `/v1/components/${componentId}:remove-from-projects`;
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Restores the given component, by undoing the soft removal of the
   * component from existing projects.
   */
  restoreComponent(componentId, body) {
    const url = `/v1/components/${componentId}:restore`;
    return this.raw.post(url, jsonify(body));
  }
  /**
   * Update a component entry
   */
  updateComponent(componentId, body) {
    const url = `/v1/components/${componentId}`;
    return this.raw.post(url, jsonify(body));
  }
}
